module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_encuentra_doctor_mobile.c8365dc0.jpg";